import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { Image } from 'react-bootstrap';
import { isEmpty } from 'lodash';

import TextNavbar from './TextNavbar';

import { ChildContainer } from './styles';

const { defaultImageSource } = Meteor.settings.public;

const ImageElement = ({
  imageSource,
  imageTitle,
  imageTitleColor,
  imageTitleSize,
  imageTitleTextSize
}) => (
  <>
    {!isEmpty(imageTitle) && (
      <TextNavbar
        navbarColor={imageTitleColor}
        navbarHeight={imageTitleSize}
        navbarText={imageTitle}
        navbarTextSize={imageTitleTextSize}
      />
    )}
    <ChildContainer heightToRemove={isEmpty(imageTitle) ? '0px' : imageTitleSize}>
      <Image src={imageSource} width="100%" height="100%" align="center" title="Image" />
    </ChildContainer>
  </>
);

ImageElement.defaultProps = {
  imageSource: defaultImageSource,
  imageTitle: '',
  imageTitleColor: 'black',
  imageTitleSize: '15px',
  imageTitleTextSize: '15px'
};

ImageElement.propTypes = {
  imageSource: PropTypes.string,
  imageTitle: PropTypes.string,
  imageTitleColor: PropTypes.string,
  imageTitleSize: PropTypes.string,
  imageTitleTextSize: PropTypes.string
};

export default ImageElement;
